'use strict';

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var usePersistentCallback = require('./usePersistentCallback-d464e155.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

/**
 * React hook that allows any component handle controlled and uncontrolled modes, and provide control over its internal state.
 * Based on https://chakra-ui.com/docs/hooks/use-controllable
 * @example
 * const Input: FC<InputProps> = ({
 *     value: valueProp,
 *     onChange = () => {},
 *     onFocus = () => {},
 *     defaultValue,
 * }) => {
 *     const [value, setValue] = useControllableStateAsEvent({
 *         value: valueProp,
 *         defaultValue,
 *         onChange
 *     });
 *      const handleChange = useCallback(
 *         (event: ChangeEvent<HTMLInputElement>) => {
 *             setValue(event.target.value, event);
 *         },
 *         [setValue]
 *     );
 *     const handleFocus = useCallback(
 *         (event: FocusEvent<HTMLInputElement>) => {
 *             onFocus(value, event);
 *         },
 *         [onFocus, value]
 *     );
 *     return (
 *         <input
 *                 value={value}
 *                 onChange={handleChange}
 *                 onFocus={handleFocus}
 *             />
 *     )
 *     //...
 */
function useControllableStateAsEvent(props) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    _props$shouldUpdate = props.shouldUpdate,
    shouldUpdate = _props$shouldUpdate === void 0 ? function (prev, next) {
      return prev !== next;
    } : _props$shouldUpdate;
  var onChangeProp = usePersistentCallback.usePersistentCallback(onChange);
  var shouldUpdateProp = usePersistentCallback.usePersistentCallback(shouldUpdate);
  var _useState = React.useState(defaultValue),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    valueState = _useState2[0],
    setValue = _useState2[1];
  var isControlled = valueProp !== undefined;
  var value = isControlled ? valueProp : valueState;
  var updateValue = React.useCallback(function (next, event) {
    var nextValue = typeof next === 'function' ? next(value) : next;
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!isControlled) {
      setValue(nextValue);
    }
    onChangeProp(event);
  }, [isControlled, onChangeProp, value, shouldUpdateProp]);
  return [value, updateValue];
}

exports.useControllableStateAsEvent = useControllableStateAsEvent;
//# sourceMappingURL=useControllableStateAsEvent-37d110e1.js.map
